function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#2574BE;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:#0F5DA8;}\n\t.st4{opacity:0.29;fill:none;stroke:#FFFFFF;stroke-width:1.0464;stroke-miterlimit:10;}\n\t.st5{opacity:0.15;}\n\t.st6{clip-path:url(#SVGID_2_);}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:0.5086;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M28.664,15.164c0,0.734-0.594,1.328-1.328,1.328c-0.35,0-0.666-0.138-0.903-0.359l-0.003,0.003L14.534,4.24l0,0 L14.5,4.207L2.597,16.11l-0.001,0c-0.24,0.236-0.569,0.383-0.932,0.383c-0.734,0-1.328-0.594-1.328-1.328 c0-0.376,0.157-0.715,0.408-0.957L13.543,1.408C13.785,1.156,14.124,1,14.5,1h0c0.024,0,0.047,0.001,0.07,0.002 c0.004,0,0.007,0.001,0.011,0.001c0.02,0.001,0.04,0.003,0.06,0.005c0.001,0,0.003,0,0.004,0c0.325,0.035,0.614,0.188,0.826,0.415 l0.001-0.001l5.225,5.225V5.426c0-0.734,0.594-1.328,1.328-1.328c0.734,0,1.328,0.594,1.328,1.328v3.876l4.956,4.955l-0.003,0.003 C28.526,14.498,28.664,14.814,28.664,15.164 M26.008,18.134v3.227v1.77v3.541c0,0.734-0.594,1.328-1.328,1.328h-6.853v-8.491h-6.971 V28H4.32c-0.734,0-1.328-0.594-1.328-1.328v-3.541v-1.77v-3.227L14.5,6.626L26.008,18.134z"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c3eb50d6.svg";
export { ForwardRef as ReactComponent };